import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { debounce, groupBy, keys } from 'lodash';

import { SelectOption } from '@platform/types';

@Component({
    selector: 'emma-dropdown',
    templateUrl: './emma-dropdown.component.html',
    standalone: false
})
export class EMMADropdownComponent implements OnChanges {
  @Input() disabled = false;
  @Input() buttonLabel = '';
  @Input() buttonIcon = '';
  @Input() color = 'metal';
  @Input() items: Array<SelectOption> = [];
  _items: Array<SelectOption> = [];
  _groupedItems: { [k: string]: Array<SelectOption> } | undefined;
  _groupedHeaders: string[] = [];

  @Input() searchable = false;
  @Input() searchBy = ['label', 'value'];
  @Input() searchTerm = '';
  @Input() showSearchInput = false;
  @Input() groupBy?: string;

  @Output() $open = new EventEmitter<void>();
  @Output() $search = new EventEmitter<string>();
  @Output() $select = new EventEmitter<string | number>();

  updateItems = debounce(() => (this._items = this.getItems()), 10);

  onOpen() {
    this.searchTerm = '';
    this.updateItems();
    this.$open.emit();
  }

  onSelect(option: SelectOption) {
    this.$select.emit(option.value);
  }

  onSearchChange(searchTerm: string) {
    this.searchTerm = searchTerm;
    this.updateItems();
  }

  getItems() {
    let items = this.items.map((item) => {
      return 'string' === typeof item
        ? {
            value: item,
            label: item,
          }
        : item;
    });
    if (this.searchable && this.searchTerm && this.searchBy && this.searchBy.length) {
      const searchString = this.searchTerm.toLowerCase();
      items = items.filter((item) => {
        for (const prop of this.searchBy) {
          if (item[prop]) {
            const value = String(item[prop]).toLocaleLowerCase();
            if (!value.includes(searchString)) {
              return false;
            }
          }
        }
        return true;
      });
    }
    if (this.groupBy) {
      this._groupedItems = groupBy(items, this.groupBy);
      this._groupedHeaders = keys(this._groupedItems);
    }
    return items;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const itemsProps: Array<keyof this> = ['items', 'searchable', 'searchBy', 'groupBy'];
    if (itemsProps.some((prop) => prop in changes)) {
      this._items = this.getItems();
      if (this.searchBy) {
        this._groupedItems = groupBy(this._items, this.groupBy);
      }
    }
  }
}
